<div class="content-app">
    <div class="row">
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
            <div class="card mt-2 mb-2">
                <div class="card-body">
                    <h5 class="mt-0 mb-2 text-primary">
                        <i class="fa-solid fa-tags"></i>   
                        Ofertas de empleo
                    </h5>
                    <div>
                        <!-- <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-briefcase"></i>
                            Todos tus matches
                            <span class="badge rounded-pill text-bg-primary">
                                {{summary.totalMatches | number}}
                            </span>
                        </button> -->
                        <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-calendar-week"></i>
                            Recientes esta semana
                            <span class="badge rounded-pill text-bg-primary">
                                {{summary.recentThisWeek | number}}
                            </span>
                        </button>
                        <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-display"></i>
                            Ofertas remotas
                            <span class="badge rounded-pill text-bg-primary">
                                {{summary.remoteOffers | number}}
                            </span>
                        </button>
                        <!-- <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-regular fa-star"></i>
                            Con alta afinidad
                            <span class="badge rounded-pill text-bg-primary">
                                {{summary.withHighAffinity | number}}
                            </span>
                        </button> -->
                    </div>
                    <hr class="mt-3 mb-3" />
                    <div class="row">
                        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                                <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-group mb-1">
                                        <div class="form-check">
                                            <input [(ngModel)]="salaryRange" class="form-check-input" type="checkbox"  id="salaryRange">
                                            <label class="form-check-label" for="salaryRange">
                                                Rango Salarial
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-group mb-1">
                                        <div class="input-group">
                                            <span class="input-group-text">Desde</span>
                                            <input [(ngModel)]="salaryRangeFrom" type="number" min="0" class="form-control" [disabled]="!salaryRange()" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-group mb-1">
                                        <div class="input-group">
                                            <span class="input-group-text">Hasta</span>
                                            <input [(ngModel)]="salaryRangeTo" type="number" min="0" class="form-control" [disabled]="!salaryRange()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mt-0 mb-0">
                                    Beneficios adicionales
                                </h6>
                                <button type="button" class="btn btn-sm btn-link text-primary" (click)="showAllBenefits.set(!showAllBenefits())">
                                    <span *ngIf="!showAllBenefits()">Ver más <i class="fa-solid fa-chevron-down"></i></span>
                                    <span *ngIf="showAllBenefits()">Ver menos <i class="fa-solid fa-chevron-up"></i></span>
                                </button>
                            </div>
                            <div class="row">
                                <!-- Mostrar solo los primeros 6 beneficios cuando está colapsado -->
                                @for (item of jobBenefits; track item.id; let i = $index) {
                                    @if (i < 6 || showAllBenefits()) {
                                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-1">
                                            <div class="form-check">
                                                <input class="form-check-input" [(ngModel)]="item.selected" type="checkbox" [value]="true" [id]="item.id">
                                                <label class="form-check-label" [for]="item.id">
                                                    {{item.text}}
                                                </label>
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                            <!-- Indicador de más beneficios disponibles -->
                            <div *ngIf="!showAllBenefits() && jobBenefits.length > 6" class="text-center mt-1 text-muted small">
                                <span>{{jobBenefits.length - 6}} beneficios más disponibles</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
            <div class="position-relative h-100">
                <div class="search-panel">
                    <app-search
                        [withOutputData]="true"
                        [typeSearch]="'Employee'"
                        (search)="changeSearch($event)"
                    ></app-search>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Resume Selector Modal -->
<div class="body-app mt-3 mb-3" *ngIf="showResumeSelector()">
    <div class="content-app">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <h5 class="mb-0">Seleccionar Currículum</h5>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info">
                            <i class="fa-solid fa-info-circle me-2"></i>
                            Por favor, seleccione un currículum para filtrar las ofertas de empleo según sus habilidades y experiencia.
                        </div>
                        
                        <div class="alert alert-light border">
                            <h6 class="mb-2"><i class="fa-solid fa-lightbulb me-2 text-warning"></i>¿Sabías que?</h6>
                            <p class="mb-1">Puedes editar tus currículums o establecer uno por defecto:</p>
                            <ul class="mb-0">
                                <li>Ve a <strong>Mis Currículums</strong></li>
                                <li>Edita un currículum existente o crea uno nuevo</li>
                                <li>Marca la opción <strong>¿Currículum por defecto?</strong></li>
                                <li>Esto evitará que tengas que seleccionar un currículum cada vez que visites esta página</li>
                            </ul>
                            <div class="mt-2">
                                <a routerLink="/candidates/my-cvs" class="btn btn-sm btn-outline-primary me-2">
                                    <i class="fa-solid fa-list me-1"></i> Mis Currículums
                                </a>
                                <a routerLink="/candidates/create-cv" class="btn btn-sm btn-outline-success">
                                    <i class="fa-solid fa-plus me-1"></i> Crear Nuevo Currículum
                                </a>
                            </div>
                        </div>
                        
                        <div *ngIf="loadingResumes()" class="text-center py-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Cargando...</span>
                            </div>
                            <p class="mt-2">Cargando currículums...</p>
                        </div>
                        
                        <div *ngIf="!loadingResumes() && resumes().length === 0" class="alert alert-warning">
                            <h6 class="mb-2"><i class="fa-solid fa-exclamation-triangle me-2"></i>No tiene currículums disponibles</h6>
                            <p class="mb-2">Debe crear un currículum para poder ver ofertas personalizadas según sus habilidades y experiencia.</p>
                            <div class="mt-2">
                                <a routerLink="/candidates/create-cv" class="btn btn-sm btn-warning">
                                    <i class="fa-solid fa-plus me-1"></i> Crear Currículum
                                </a>
                            </div>
                        </div>
                        
                        <div *ngIf="!loadingResumes() && resumes().length > 0" class="row">
                            <div class="col-12">
                                <div class="form-group mb-3">
                                    <label class="form-label">Seleccione un currículum:</label>
                                    <select [ngModel]="selectedResumeId()" (ngModelChange)="selectedResumeId.set($event)" class="form-select">
                                        <option [ngValue]="null">Seleccione un currículum</option>
                                        <option *ngFor="let resume of resumes()" [ngValue]="resume.id">{{ resume.name }}</option>
                                    </select>
                                </div>
                                
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button [disabled]="!selectedResumeId()" (click)="selectResume(selectedResumeId()!)" class="btn btn-primary">
                                        <i class="fa-solid fa-check me-2"></i>
                                        Continuar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main Content -->
<div class="body-app mt-3 mb-3" *ngIf="!showResumeSelector()">
    <div class="content-app">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <ul class="nav nav-tabs nav-tabs-ofertas" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" (click)="changeTab(1)" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">
                            Ofertas
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" (click)="changeTab(3)" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">
                            No me interesa
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" (click)="changeTab(2)" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">
                            Favoritos
                        </button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                        <div class="row">
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingResume()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="resume().photoUrl" onerror="this.src='assets/Images/user.png'" alt="Compania" class="img-fluid logo-company-card-ofert">
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().userName}}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().name}}
                                                    </h6>
                                                    <a [routerLink]="['/candidates', 'cv', resume().id]" class="btn btn-light text-decoration-none text-primary">
                                                        Editar Perfil
                                                        <i class="fa-solid fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        }
                                        <hr class="mt-3 mb-3" />
                                        <ul class="text-medium">
                                            @for (item of resume().skillList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Habilidades Complementarias
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().softSkillsList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Idiomas
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().languagesList; track $index) {
                                                <li>{{ item.name }}</li>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    {{ item.level }}
                                                </span>
                                            }
                                        </ul>
                                        <!-- <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2 d-flex">
                                            <div class="input-group me-1">
                                                <input type="text" class="form-control" value="https://redlaboral.com/OscarAcostaRD" readonly />
                                                <button type="button" class="btn btn-primary">
                                                    <i class="fa-regular fa-copy"></i>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-brands fa-x-twitter"></i>
                                            </button>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-regular fa-envelope"></i>
                                            </button>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                                <div class="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <button type="button" class="btn btn-outline-primary my-4" 
                                    [disabled]="getCurrentPage() <= 1"
                                    (click)="previousPage()">
                                        <i class="fa-solid fa-circle-arrow-up"></i>
                                    </button>
                                    <div class="wrap-circles">
                                        <div class="circle per-25"
                                        [ngStyle]="{
                                            'background-image': 'conic-gradient(#0d1174 ' + matchPercent() + '%, #eee 0)'
                                          }">
                                            <div class="inner">{{matchPercent()}}%</div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-outline-primary my-4"
                                    [disabled]="getCurrentPage() >= getTotalPages()"
                                    (click)="nextPage()">
                                        <i class="fa-solid fa-circle-arrow-down"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingJobs()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else if(!activeJobsHomePage()) {
                                            <div class="alert alert-info text-center py-4">
                                                <i class="fa-solid fa-info-circle fa-2x mb-3 d-block"></i>
                                                <h5>No se encontró un match disponible</h5>
                                                <p>Intenta editando tu CV o seleccionando otro como Default o principal para encontrar mejores coincidencias.</p>
                                                <a [routerLink]="['/candidates', 'cv', resume().id]" class="btn btn-primary mt-2">
                                                    <i class="fa-solid fa-pen-to-square me-2"></i>Editar mi CV
                                                </a>
                                            </div>
                                        } @else {
                                            <p class="mt-0 mb-2 text-secondary text-medium">
                                                <i class="fa-regular fa-clock"></i>
                                                {{activeJobsHomePage()?.publicOnDescripcion}}
                                            </p>
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="activeJobsHomePage()?.logoUrl" onerror="this.error=null; this.src='assets/Images/no-image.jpg'" alt="Logo" class="img-fluid logo-company logo-company-card-ofert" />
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.ownerFullName }}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.offerTitle }}
                                                    </h6>
                                                    <p class="mt-0 mb-1 text-medium text-secondary">
                                                        <i class="fa-solid fa-coins"></i>
                                                        {{ activeJobsHomePage()?.proposedSalary | number }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="text-start mt-3 mb-1">
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-location-dot"></i>
                                                    {{activeJobsHomePage()?.countryName}} 
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-briefcase"></i>
                                                    {{activeJobsHomePage()?.departmentName}}
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-regular fa-clock"></i>
                                                    {{activeJobsHomePage()?.contractType}}
                                                </span>
                                                <br />
                                            </p>
                                            @if(activeJobsHomePage()){
                                                <a class="btn btn-light text-decoration-none text-primary"
                                                [routerLink]="['/home/job', activeJobsHomePage()?.id]">
                                                   Ver detalles de la oferta
                                                   <i class="fa-solid fa-chevron-right"></i>
                                               </a>
                                            }
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades técnicas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.skillList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades Complementarias
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.softSkillsList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Idiomas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.languagesList; track $index) {
                                                    <li>{{ item.name }}</li>
                                                    <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                        {{ item.level }}
                                                    </span>
                                                }
                                            </ul>
                                        }
                                        <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2">
                                            @if(activeJobsHomePage()){
                                                <button (click)="addJobApplicationsNotInterested()" type="button" class="btn btn-outline-secondary me-1">
                                                    Descartar
                                                </button>
                                                <button type="button" (click)="applyOffer()" class="btn btn-primary me-1">
                                                    Quiero postularme
                                                </button>
                                                <button (click)="addJobApplicationsFavorite()" type="button" class="btn btn-outline-primary me-1">
                                                    <i class="fa-regular fa-star"></i>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                        <div class="row">
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingResume()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="resume().photoUrl" onerror="this.error=null; this.src='assets/Images/user.png'" alt="Compania" class="img-fluid logo-company-card-ofert">
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().userName}}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().name}}
                                                    </h6>
                                                    <a [routerLink]="['/candidates', 'cv', resume().id]" class="btn btn-light text-decoration-none text-primary">
                                                        Editar Perfil
                                                        <i class="fa-solid fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        }
                                        <hr class="mt-3 mb-3" />
                                        <ul class="text-medium">
                                            @for (item of resume().skillList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Habilidades Complementarias
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().softSkillsList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Idiomas
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().languagesList; track $index) {
                                                <li>{{ item.name }}</li>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    {{ item.level }}
                                                </span>
                                            }
                                        </ul>
                                        <!-- <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2 d-flex">
                                            <div class="input-group me-1">
                                                <input type="text" class="form-control" value="https://redlaboral.com/OscarAcostaRD" readonly />
                                                <button type="button" class="btn btn-primary">
                                                    <i class="fa-regular fa-copy"></i>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-brands fa-x-twitter"></i>
                                            </button>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-regular fa-envelope"></i>
                                            </button>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                                <div class="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <button type="button" class="btn btn-outline-primary my-4" 
                                     [disabled]="getCurrentPage() <= 1"
                                     (click)="previousPage()">
                                        <i class="fa-solid fa-circle-arrow-up"></i>
                                    </button>
                                    <div class="wrap-circles">
                                        <div class="circle per-25"
                                        [ngStyle]="{
                                            'background-image': 'conic-gradient(#0d1174 ' + matchPercent() + '%, #eee 0)'
                                          }">
                                            <div class="inner">{{matchPercent()}}%</div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-outline-primary my-4"
                                     [disabled]="getCurrentPage() >= getTotalPages()"
                                     (click)="nextPage()">
                                        <i class="fa-solid fa-circle-arrow-down"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingJobs()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else if(!activeJobsHomePage()) {
                                            <div class="alert alert-info text-center py-4">
                                                <i class="fa-solid fa-info-circle fa-2x mb-3 d-block"></i>
                                                <h5>No tienes ofertas marcadas como No Interesado</h5>
                                            </div>
                                        } @else {
                                            <p class="mt-0 mb-2 text-secondary text-medium">
                                                <i class="fa-regular fa-clock"></i>
                                                {{activeJobsHomePage()?.publicOnDescripcion}}
                                            </p>
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="activeJobsHomePage()?.logoUrl" onerror="this.error=null; this.src='assets/Images/no-image.jpg'" alt="Logo" class="img-fluid logo-company logo-company-card-ofert" />
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.ownerFullName }}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.offerTitle }}
                                                    </h6>
                                                    <p class="mt-0 mb-1 text-medium text-secondary">
                                                        <i class="fa-solid fa-coins"></i>
                                                        {{ activeJobsHomePage()?.proposedSalary | number }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="text-start mt-3 mb-1">
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-location-dot"></i>
                                                    {{activeJobsHomePage()?.countryName}} 
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-briefcase"></i>
                                                    {{activeJobsHomePage()?.departmentName}}
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-regular fa-clock"></i>
                                                    {{activeJobsHomePage()?.contractType}}
                                                </span>
                                                <br />
                                            </p>
                                            @if(activeJobsHomePage()){
                                                <a class="btn btn-light text-decoration-none text-primary"
                                                [routerLink]="['/home/job', activeJobsHomePage()?.id]">
                                                   Ver detalles de la oferta
                                                   <i class="fa-solid fa-chevron-right"></i>
                                               </a>
                                            }
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades técnicas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.skillList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades Complementarias
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.softSkillsList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Idiomas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.languagesList; track $index) {
                                                    <li>{{ item.name }}</li>
                                                    <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                        {{ item.level }}
                                                    </span>
                                                }
                                            </ul>
                                        }
                                        <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2">
                                            <!-- <button (click)="addJobApplicationsNotInterested()" type="button" class="btn btn-outline-secondary me-1">
                                                Descartar
                                            </button> -->
                                            <!-- <button type="button" class="btn btn-primary me-1">
                                                Quiero postularme
                                            </button> -->
                                            @if(activeJobsHomePage()){
                                                <button (click)="addJobApplicationsFavorite()" type="button" class="btn btn-outline-primary me-1">
                                                    <i class="fa-regular fa-star"></i>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                        <div class="row">
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingResume()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="resume().photoUrl" onerror="this.error=null; this.src='assets/Images/user.png'" alt="Compania" class="img-fluid logo-company-card-ofert">
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().userName}}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{resume().name}}
                                                    </h6>
                                                    <a [routerLink]="['/candidates', 'cv', resume().id]" class="btn btn-light text-decoration-none text-primary">
                                                        Editar Perfil
                                                        <i class="fa-solid fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        }
                                        <hr class="mt-3 mb-3" />
                                        <ul class="text-medium">
                                            @for (item of resume().skillList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Habilidades Complementarias
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().softSkillsList; track $index) {
                                                <li>{{ item }}</li>
                                            }
                                        </ul>
                                        <h6 class="mt-0 mb-1 fw-bold">
                                            Idiomas
                                        </h6>
                                        <ul class="text-medium">
                                            @for (item of resume().languagesList; track $index) {
                                                <li>{{ item.name }}</li>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    {{ item.level }}
                                                </span>
                                            }
                                        </ul>
                                        <!-- <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2 d-flex">
                                            <div class="input-group me-1">
                                                <input type="text" class="form-control" value="https://redlaboral.com/OscarAcostaRD" readonly />
                                                <button type="button" class="btn btn-primary">
                                                    <i class="fa-regular fa-copy"></i>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-brands fa-x-twitter"></i>
                                            </button>
                                            <button type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-regular fa-envelope"></i>
                                            </button>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                                <div class="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <button type="button" class="btn btn-outline-primary my-4" 
                                     [disabled]="getCurrentPage() <= 1"
                                     (click)="previousPage()">
                                        <i class="fa-solid fa-circle-arrow-up"></i>
                                    </button>
                                    <div class="wrap-circles">
                                        <div class="circle per-25"
                                        [ngStyle]="{
                                            'background-image': 'conic-gradient(#0d1174 ' + matchPercent() + '%, #eee 0)'
                                          }">
                                            <div class="inner">{{matchPercent()}}%</div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-outline-primary my-4"
                                     [disabled]="getCurrentPage() >= getTotalPages()"
                                     (click)="nextPage()">
                                        <i class="fa-solid fa-circle-arrow-down"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                <div class="card card-redlaboral">
                                    <div class="card-body">
                                        @if(loadingJobs()) {
                                            <div class="d-flex justify-content-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        } @else if(!activeJobsHomePage()) {
                                            <div class="alert alert-info text-center py-4">
                                                <i class="fa-solid fa-info-circle fa-2x mb-3 d-block"></i>
                                                <h5>No tienes ofertas marcadas como favoritas.</h5>
                                                <p>Intenta marcando alguna de tus ofertas disponibles.</p>
                                            </div>
                                        }@else {
                                            <p class="mt-0 mb-2 text-secondary text-medium">
                                                <i class="fa-regular fa-clock"></i>
                                                {{activeJobsHomePage()?.publicOnDescripcion}}
                                            </p>
                                            <div class="row">
                                                <div class="col-auto">
                                                    <img [src]="activeJobsHomePage()?.logoUrl" onerror="this.error=null; this.src='assets/Images/no-image.jpg'" alt="Logo" class="img-fluid logo-company logo-company-card-ofert" />
                                                </div>
                                                <div class="col">
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.ownerFullName }}
                                                    </h6>
                                                    <h6 class="mt-0 mb-1">
                                                        {{ activeJobsHomePage()?.offerTitle }}
                                                    </h6>
                                                    <p class="mt-0 mb-1 text-medium text-secondary">
                                                        <i class="fa-solid fa-coins"></i>
                                                        {{ activeJobsHomePage()?.proposedSalary | number }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="text-start mt-3 mb-1">
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-location-dot"></i>
                                                    {{activeJobsHomePage()?.countryName}}
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-solid fa-briefcase"></i>
                                                    {{activeJobsHomePage()?.departmentName}}
                                                </span>
                                                <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                    <i class="fa-regular fa-clock"></i>
                                                    {{activeJobsHomePage()?.contractType}}
                                                </span>
                                                <br />
                                            </p>
                                            @if(activeJobsHomePage()){
                                                <a class="btn btn-light text-decoration-none text-primary"
                                                [routerLink]="['/home/job', activeJobsHomePage()?.id]">
                                                   Ver detalles de la oferta
                                                   <i class="fa-solid fa-chevron-right"></i>
                                               </a>
                                            }
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades técnicas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.skillList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Habilidades Complementarias
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.softSkillsList; track $index) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                            <h6 class="mt-0 mb-1 fw-bold">
                                                Idiomas
                                            </h6>
                                            <ul class="text-medium">
                                                @for (item of activeJobsHomePage()?.languagesList; track $index) {
                                                    <li>{{ item.name }}</li>
                                                    <span class="badge rounded-pill text-bg-secondary d-inline-block me-1">
                                                        {{ item.level }}
                                                    </span>
                                                }
                                            </ul>
                                        }
                                        <br /><br />
                                        <hr class="mt-3 mb-3" />
                                        <div class="mt-2 mb-2">
                                            @if(activeJobsHomePage()){
                                                <button (click)="addJobApplicationsNotInterested()" type="button" class="btn btn-outline-secondary me-1">
                                                    Descartar
                                                </button>
                                                <button type="button" (click)="applyOffer()" class="btn btn-primary me-1">
                                                    Quiero postularme
                                                </button>
                                            }
                                            <!-- <button (click)="addJobApplicationsFavorite()" type="button" class="btn btn-outline-primary me-1">
                                                <i class="fa-regular fa-star"></i>
                                            </button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <br />
                <!-- <ul class="list-group">
                    <li class="list-group-item list-group-item-job" *ngFor="let item of items">
                        <div class="row">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4">
                                <img [src]="item.logo" alt="Logo" class="img-fluid logo-company" />
                            </div>
                            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-7">
                                <a routerLink="/home/job" class="text-decoration-none fs-5 mt-0 mb-0">
                                    {{ item.oferta }}
                                </a>
                                <br />
                                <a routerLink="/home/job" class="text-decoration-none mt-0 mb-2">
                                    <i class="fa-regular fa-building text-primary"></i>
                                    {{ item.compania }}
                                </a>
                                <p class="mt-0 mb-2">
                                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Alias, assumenda corporis. Eaque, aliquid magnam? Ex, voluptates architecto doloribus vel, fugiat totam...
                                </p>
                                <div class="row mb-2">
                                    <div class="col-md-4 col-sm-6 col-12">
                                        <i class="fa-regular fa-clock text-primary"></i>
                                        {{ item.tiempo }}
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-12">
                                        <i class="fa-regular fa-calendar text-primary"></i>
                                        {{ item.date }}
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-12">
                                        <i class="fa-solid fa-location-dot text-primary"></i>
                                        {{ item.location }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
            </div>
        </div>
    </div>
</div>

